import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var MappingType = /*#__PURE__*/function (MappingType) {
  MappingType[MappingType["MAPPING_TYPE_UNSPECIFIED"] = 0] = "MAPPING_TYPE_UNSPECIFIED";
  MappingType[MappingType["MAPPING_TYPE_LOOKUP_CUSTOM_FIELD"] = 1] = "MAPPING_TYPE_LOOKUP_CUSTOM_FIELD";
  MappingType[MappingType["MAPPING_TYPE_CUSTOM_FIELD"] = 2] = "MAPPING_TYPE_CUSTOM_FIELD";
  MappingType[MappingType["MAPPING_TYPE_SYSTEM_FIELD"] = 3] = "MAPPING_TYPE_SYSTEM_FIELD";
  return MappingType;
}(MappingType || {});
var MergeStrategyType = /*#__PURE__*/function (MergeStrategyType) {
  MergeStrategyType[MergeStrategyType["MERGE_STRATEGY_UNSPECIFIED"] = 0] = "MERGE_STRATEGY_UNSPECIFIED";
  MergeStrategyType[MergeStrategyType["MERGE_STRATEGY_ALWAYS_OVERWRITE"] = 1] = "MERGE_STRATEGY_ALWAYS_OVERWRITE";
  MergeStrategyType[MergeStrategyType["MERGE_STRATEGY_OVERWRITE_IF_EMPTY"] = 2] = "MERGE_STRATEGY_OVERWRITE_IF_EMPTY";
  MergeStrategyType[MergeStrategyType["MERGE_STRATEGY_OVERWRITE_IF_NEWER"] = 3] = "MERGE_STRATEGY_OVERWRITE_IF_NEWER";
  MergeStrategyType[MergeStrategyType["MERGE_STRATEGY_COMBINE"] = 4] = "MERGE_STRATEGY_COMBINE";
  return MergeStrategyType;
}(MergeStrategyType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var WorkflowStatus = /*#__PURE__*/function (WorkflowStatus) {
  WorkflowStatus[WorkflowStatus["WORKFLOW_STATUS_INVALID"] = 0] = "WORKFLOW_STATUS_INVALID";
  WorkflowStatus[WorkflowStatus["WORKFLOW_STATUS_IN_PROGRESS"] = 1] = "WORKFLOW_STATUS_IN_PROGRESS";
  WorkflowStatus[WorkflowStatus["WORKFLOW_STATUS_SUCCEEDED"] = 2] = "WORKFLOW_STATUS_SUCCEEDED";
  WorkflowStatus[WorkflowStatus["WORKFLOW_STATUS_FAILED"] = 3] = "WORKFLOW_STATUS_FAILED";
  return WorkflowStatus;
}(WorkflowStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DateDefault = /*#__PURE__*/function (DateDefault) {
  DateDefault[DateDefault["DATE_DEFAULT_INVALID"] = 0] = "DATE_DEFAULT_INVALID";
  DateDefault[DateDefault["DATE_DEFAULT_TODAY"] = 1] = "DATE_DEFAULT_TODAY";
  DateDefault[DateDefault["DATE_DEFAULT_YESTERDAY"] = 2] = "DATE_DEFAULT_YESTERDAY";
  DateDefault[DateDefault["DATE_DEFAULT_TOMORROW"] = 3] = "DATE_DEFAULT_TOMORROW";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_WEEK"] = 4] = "DATE_DEFAULT_THIS_WEEK";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_WEEK"] = 5] = "DATE_DEFAULT_LAST_WEEK";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_WEEK"] = 6] = "DATE_DEFAULT_NEXT_WEEK";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_MONTH"] = 7] = "DATE_DEFAULT_THIS_MONTH";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_MONTH"] = 8] = "DATE_DEFAULT_LAST_MONTH";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_MONTH"] = 9] = "DATE_DEFAULT_NEXT_MONTH";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_QUARTER"] = 10] = "DATE_DEFAULT_THIS_QUARTER";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_QUARTER"] = 11] = "DATE_DEFAULT_LAST_QUARTER";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_QUARTER"] = 12] = "DATE_DEFAULT_NEXT_QUARTER";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_YEAR"] = 13] = "DATE_DEFAULT_THIS_YEAR";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_YEAR"] = 14] = "DATE_DEFAULT_LAST_YEAR";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_YEAR"] = 15] = "DATE_DEFAULT_NEXT_YEAR";
  return DateDefault;
}(DateDefault || {});
var FilterGroupOperator = /*#__PURE__*/function (FilterGroupOperator) {
  FilterGroupOperator[FilterGroupOperator["FILTER_GROUP_OPERATOR_INVALID"] = 0] = "FILTER_GROUP_OPERATOR_INVALID";
  FilterGroupOperator[FilterGroupOperator["FILTER_GROUP_OPERATOR_AND"] = 1] = "FILTER_GROUP_OPERATOR_AND";
  FilterGroupOperator[FilterGroupOperator["FILTER_GROUP_OPERATOR_OR"] = 2] = "FILTER_GROUP_OPERATOR_OR";
  return FilterGroupOperator;
}(FilterGroupOperator || {});
var FilterOperator = /*#__PURE__*/function (FilterOperator) {
  FilterOperator[FilterOperator["FILTER_OPERATOR_INVALID"] = 0] = "FILTER_OPERATOR_INVALID";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_EMPTY"] = 1] = "FILTER_OPERATOR_IS_EMPTY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_EMPTY"] = 2] = "FILTER_OPERATOR_IS_NOT_EMPTY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS"] = 3] = "FILTER_OPERATOR_IS";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT"] = 4] = "FILTER_OPERATOR_IS_NOT";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_ANY"] = 5] = "FILTER_OPERATOR_IS_ANY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_ANY"] = 6] = "FILTER_OPERATOR_IS_NOT_ANY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_ALL"] = 7] = "FILTER_OPERATOR_IS_ALL";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_ALL"] = 8] = "FILTER_OPERATOR_IS_NOT_ALL";
  FilterOperator[FilterOperator["FILTER_OPERATOR_CONTAINS"] = 9] = "FILTER_OPERATOR_CONTAINS";
  FilterOperator[FilterOperator["FILTER_OPERATOR_DOES_NOT_CONTAIN"] = 10] = "FILTER_OPERATOR_DOES_NOT_CONTAIN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_EQUAL_TO"] = 11] = "FILTER_OPERATOR_IS_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_EQUAL_TO"] = 12] = "FILTER_OPERATOR_IS_NOT_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_GREATER_THAN"] = 13] = "FILTER_OPERATOR_IS_GREATER_THAN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO"] = 14] = "FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_LESS_THAN"] = 15] = "FILTER_OPERATOR_IS_LESS_THAN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO"] = 16] = "FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_BEFORE"] = 17] = "FILTER_OPERATOR_IS_BEFORE";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_BEFORE_OR_ON"] = 18] = "FILTER_OPERATOR_IS_BEFORE_OR_ON";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_AFTER"] = 19] = "FILTER_OPERATOR_IS_AFTER";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_AFTER_OR_ON"] = 20] = "FILTER_OPERATOR_IS_AFTER_OR_ON";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_BETWEEN"] = 21] = "FILTER_OPERATOR_IS_BETWEEN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_BETWEEN"] = 22] = "FILTER_OPERATOR_IS_NOT_BETWEEN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_VALID"] = 23] = "FILTER_OPERATOR_IS_VALID";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_VALID"] = 24] = "FILTER_OPERATOR_IS_NOT_VALID";
  return FilterOperator;
}(FilterOperator || {});
var FilterType = /*#__PURE__*/function (FilterType) {
  FilterType[FilterType["FILTER_TYPE_INVALID"] = 0] = "FILTER_TYPE_INVALID";
  FilterType[FilterType["FILTER_TYPE_STRING"] = 1] = "FILTER_TYPE_STRING";
  FilterType[FilterType["FILTER_TYPE_INTEGER"] = 2] = "FILTER_TYPE_INTEGER";
  FilterType[FilterType["FILTER_TYPE_DATE"] = 3] = "FILTER_TYPE_DATE";
  FilterType[FilterType["FILTER_TYPE_FLOAT"] = 4] = "FILTER_TYPE_FLOAT";
  FilterType[FilterType["FILTER_TYPE_BOOLEAN"] = 5] = "FILTER_TYPE_BOOLEAN";
  FilterType[FilterType["FILTER_TYPE_TAG"] = 6] = "FILTER_TYPE_TAG";
  FilterType[FilterType["FILTER_TYPE_PHONE"] = 8] = "FILTER_TYPE_PHONE";
  return FilterType;
}(FilterType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var FieldType = /*#__PURE__*/function (FieldType) {
  FieldType[FieldType["FIELD_TYPE_INVALID"] = 0] = "FIELD_TYPE_INVALID";
  FieldType[FieldType["FIELD_TYPE_STRING"] = 1] = "FIELD_TYPE_STRING";
  FieldType[FieldType["FIELD_TYPE_INTEGER"] = 2] = "FIELD_TYPE_INTEGER";
  FieldType[FieldType["FIELD_TYPE_DATE"] = 3] = "FIELD_TYPE_DATE";
  FieldType[FieldType["FIELD_TYPE_DROPDOWN"] = 4] = "FIELD_TYPE_DROPDOWN";
  FieldType[FieldType["FIELD_TYPE_CURRENCY"] = 5] = "FIELD_TYPE_CURRENCY";
  FieldType[FieldType["FIELD_TYPE_EMAIL"] = 6] = "FIELD_TYPE_EMAIL";
  FieldType[FieldType["FIELD_TYPE_PHONE"] = 7] = "FIELD_TYPE_PHONE";
  FieldType[FieldType["FIELD_TYPE_BOOLEAN"] = 8] = "FIELD_TYPE_BOOLEAN";
  FieldType[FieldType["FIELD_TYPE_TAG"] = 9] = "FIELD_TYPE_TAG";
  FieldType[FieldType["FIELD_TYPE_DATETIME"] = 10] = "FIELD_TYPE_DATETIME";
  FieldType[FieldType["FIELD_TYPE_STRING_LIST"] = 11] = "FIELD_TYPE_STRING_LIST";
  FieldType[FieldType["FIELD_TYPE_GEOPOINT"] = 12] = "FIELD_TYPE_GEOPOINT";
  FieldType[FieldType["FIELD_TYPE_FLOAT"] = 13] = "FIELD_TYPE_FLOAT";
  return FieldType;
}(FieldType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ValidateCrmObjectResponseFieldUniqueness = /*#__PURE__*/function (ValidateCrmObjectResponseFieldUniqueness) {
  ValidateCrmObjectResponseFieldUniqueness[ValidateCrmObjectResponseFieldUniqueness["FIELD_UNIQUENESS_INVALID"] = 0] = "FIELD_UNIQUENESS_INVALID";
  ValidateCrmObjectResponseFieldUniqueness[ValidateCrmObjectResponseFieldUniqueness["FIELD_UNIQUENESS_NONE"] = 1] = "FIELD_UNIQUENESS_NONE";
  ValidateCrmObjectResponseFieldUniqueness[ValidateCrmObjectResponseFieldUniqueness["FIELD_UNIQUENESS_WARNING"] = 2] = "FIELD_UNIQUENESS_WARNING";
  ValidateCrmObjectResponseFieldUniqueness[ValidateCrmObjectResponseFieldUniqueness["FIELD_UNIQUENESS_ENFORCED"] = 3] = "FIELD_UNIQUENESS_ENFORCED";
  return ValidateCrmObjectResponseFieldUniqueness;
}(ValidateCrmObjectResponseFieldUniqueness || {});
var ProjectionFilterType = /*#__PURE__*/function (ProjectionFilterType) {
  ProjectionFilterType[ProjectionFilterType["PROJECTION_FILTER_TYPE_INVALID"] = 0] = "PROJECTION_FILTER_TYPE_INVALID";
  ProjectionFilterType[ProjectionFilterType["PROJECTION_FILTER_TYPE_FIELD_TYPE"] = 1] = "PROJECTION_FILTER_TYPE_FIELD_TYPE";
  return ProjectionFilterType;
}(ProjectionFilterType || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_INVALID"] = 0] = "SORT_DIRECTION_INVALID";
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 1] = "SORT_DIRECTION_ASCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 2] = "SORT_DIRECTION_DESCENDING";
  return SortDirection;
}(SortDirection || {});
var ValidateCrmObjectResponseValidationErrorSeverity = /*#__PURE__*/function (ValidateCrmObjectResponseValidationErrorSeverity) {
  ValidateCrmObjectResponseValidationErrorSeverity[ValidateCrmObjectResponseValidationErrorSeverity["VALIDATION_ERROR_SEVERITY_UNKNOWN"] = 0] = "VALIDATION_ERROR_SEVERITY_UNKNOWN";
  ValidateCrmObjectResponseValidationErrorSeverity[ValidateCrmObjectResponseValidationErrorSeverity["VALIDATION_ERROR_SEVERITY_INVALID"] = 1] = "VALIDATION_ERROR_SEVERITY_INVALID";
  ValidateCrmObjectResponseValidationErrorSeverity[ValidateCrmObjectResponseValidationErrorSeverity["VALIDATION_ERROR_SEVERITY_WARNING"] = 2] = "VALIDATION_ERROR_SEVERITY_WARNING";
  return ValidateCrmObjectResponseValidationErrorSeverity;
}(ValidateCrmObjectResponseValidationErrorSeverity || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AddContactAsIamUserForCompanyStatus = /*#__PURE__*/function (AddContactAsIamUserForCompanyStatus) {
  AddContactAsIamUserForCompanyStatus[AddContactAsIamUserForCompanyStatus["ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_INVALID"] = 0] = "ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_INVALID";
  AddContactAsIamUserForCompanyStatus[AddContactAsIamUserForCompanyStatus["ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_IN_PROGRESS"] = 1] = "ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_IN_PROGRESS";
  AddContactAsIamUserForCompanyStatus[AddContactAsIamUserForCompanyStatus["ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_SUCCEEDED"] = 2] = "ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_SUCCEEDED";
  AddContactAsIamUserForCompanyStatus[AddContactAsIamUserForCompanyStatus["ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_FAILED"] = 3] = "ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_FAILED";
  return AddContactAsIamUserForCompanyStatus;
}(AddContactAsIamUserForCompanyStatus || {});
var CreateAccountGroupForCompanyStatus = /*#__PURE__*/function (CreateAccountGroupForCompanyStatus) {
  CreateAccountGroupForCompanyStatus[CreateAccountGroupForCompanyStatus["CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_UNSPECIFIED"] = 0] = "CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_UNSPECIFIED";
  CreateAccountGroupForCompanyStatus[CreateAccountGroupForCompanyStatus["CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_IN_PROGRESS"] = 1] = "CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_IN_PROGRESS";
  CreateAccountGroupForCompanyStatus[CreateAccountGroupForCompanyStatus["CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_SUCCEEDED"] = 2] = "CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_SUCCEEDED";
  CreateAccountGroupForCompanyStatus[CreateAccountGroupForCompanyStatus["CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_FAILED"] = 3] = "CREATE_ACCOUNT_GROUP_FOR_COMPANY_STATUS_FAILED";
  return CreateAccountGroupForCompanyStatus;
}(CreateAccountGroupForCompanyStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var NullValue = /*#__PURE__*/function (NullValue) {
  NullValue[NullValue["NULL_VALUE"] = 0] = "NULL_VALUE";
  return NullValue;
}(NullValue || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateIntegrationRequest {
  static fromProto(proto) {
    let m = new CreateIntegrationRequest();
    m = Object.assign(m, proto);
    if (proto.integration) {
      m.integration = Integration.fromProto(proto.integration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integration !== 'undefined' && this.integration !== null) {
      toReturn['integration'] = 'toApiJson' in this.integration ? this.integration.toApiJson() : this.integration;
    }
    return toReturn;
  }
}
class CreateIntegrationResponse {
  static fromProto(proto) {
    let m = new CreateIntegrationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    return toReturn;
  }
}
class MergeStrategyMergeConfigDateOverwriteConfig {
  static fromProto(proto) {
    let m = new MergeStrategyMergeConfigDateOverwriteConfig();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dateCriteriaFieldId !== 'undefined') {
      toReturn['dateCriteriaFieldId'] = this.dateCriteriaFieldId;
    }
    return toReturn;
  }
}
class DeleteIntegrationRequest {
  static fromProto(proto) {
    let m = new DeleteIntegrationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    return toReturn;
  }
}
class FieldMapping {
  static fromProto(proto) {
    let m = new FieldMapping();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$9(MappingType, proto.type);
    }
    if (proto.mergeStrategy) {
      m.mergeStrategy = MergeStrategy.fromProto(proto.mergeStrategy);
    }
    if (proto.nestedIntegration) {
      m.nestedIntegration = NestedIntegration.fromProto(proto.nestedIntegration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.jsonPath !== 'undefined') {
      toReturn['jsonPath'] = this.jsonPath;
    }
    if (typeof this.mergeStrategy !== 'undefined' && this.mergeStrategy !== null) {
      toReturn['mergeStrategy'] = 'toApiJson' in this.mergeStrategy ? this.mergeStrategy.toApiJson() : this.mergeStrategy;
    }
    if (typeof this.nestedIntegration !== 'undefined' && this.nestedIntegration !== null) {
      toReturn['nestedIntegration'] = 'toApiJson' in this.nestedIntegration ? this.nestedIntegration.toApiJson() : this.nestedIntegration;
    }
    return toReturn;
  }
}
class GetMultiIntegrationRequest {
  static fromProto(proto) {
    let m = new GetMultiIntegrationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationIds !== 'undefined') {
      toReturn['integrationIds'] = this.integrationIds;
    }
    return toReturn;
  }
}
class GetMultiIntegrationResponse {
  static fromProto(proto) {
    let m = new GetMultiIntegrationResponse();
    m = Object.assign(m, proto);
    if (proto.integrations) {
      m.integrations = proto.integrations.map(Integration.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrations !== 'undefined' && this.integrations !== null) {
      toReturn['integrations'] = 'toApiJson' in this.integrations ? this.integrations.toApiJson() : this.integrations;
    }
    return toReturn;
  }
}
class Integration {
  static fromProto(proto) {
    let m = new Integration();
    m = Object.assign(m, proto);
    if (proto.fieldMappings) {
      m.fieldMappings = proto.fieldMappings.map(FieldMapping.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.objectType !== 'undefined') {
      toReturn['objectType'] = this.objectType;
    }
    if (typeof this.objectSubtype !== 'undefined') {
      toReturn['objectSubtype'] = this.objectSubtype;
    }
    if (typeof this.lookupMappingIds !== 'undefined') {
      toReturn['lookupMappingIds'] = this.lookupMappingIds;
    }
    if (typeof this.fieldMappings !== 'undefined' && this.fieldMappings !== null) {
      toReturn['fieldMappings'] = 'toApiJson' in this.fieldMappings ? this.fieldMappings.toApiJson() : this.fieldMappings;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class MergeStrategyMergeConfig {
  static fromProto(proto) {
    let m = new MergeStrategyMergeConfig();
    m = Object.assign(m, proto);
    if (proto.dateOverwriteConfig) {
      m.dateOverwriteConfig = MergeStrategyMergeConfigDateOverwriteConfig.fromProto(proto.dateOverwriteConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dateOverwriteConfig !== 'undefined' && this.dateOverwriteConfig !== null) {
      toReturn['dateOverwriteConfig'] = 'toApiJson' in this.dateOverwriteConfig ? this.dateOverwriteConfig.toApiJson() : this.dateOverwriteConfig;
    }
    return toReturn;
  }
}
class MergeStrategy {
  static fromProto(proto) {
    let m = new MergeStrategy();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$9(MergeStrategyType, proto.type);
    }
    if (proto.config) {
      m.config = MergeStrategyMergeConfig.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class NestedIntegration {
  static fromProto(proto) {
    let m = new NestedIntegration();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    return toReturn;
  }
}
class UpdateIntegrationRequest {
  static fromProto(proto) {
    let m = new UpdateIntegrationRequest();
    m = Object.assign(m, proto);
    if (proto.integration) {
      m.integration = Integration.fromProto(proto.integration);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integration !== 'undefined' && this.integration !== null) {
      toReturn['integration'] = 'toApiJson' in this.integration ? this.integration.toApiJson() : this.integration;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Filter {
  static fromProto(proto) {
    let m = new Filter();
    m = Object.assign(m, proto);
    if (proto.operator) {
      m.operator = enumStringToValue$7(FilterOperator, proto.operator);
    }
    if (proto.values) {
      m.values = proto.values.map(FilterValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.values !== 'undefined' && this.values !== null) {
      toReturn['values'] = 'toApiJson' in this.values ? this.values.toApiJson() : this.values;
    }
    if (typeof this.floatTolerance !== 'undefined') {
      toReturn['floatTolerance'] = this.floatTolerance;
    }
    return toReturn;
  }
}
class FilterGroup {
  static fromProto(proto) {
    let m = new FilterGroup();
    m = Object.assign(m, proto);
    if (proto.operator) {
      m.operator = enumStringToValue$7(FilterGroupOperator, proto.operator);
    }
    if (proto.filters) {
      m.filters = proto.filters.map(Filter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class Phone {
  static fromProto(proto) {
    let m = new Phone();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isoCountryCode !== 'undefined') {
      toReturn['isoCountryCode'] = this.isoCountryCode;
    }
    if (typeof this.nationalNumber !== 'undefined') {
      toReturn['nationalNumber'] = this.nationalNumber;
    }
    if (typeof this.extension !== 'undefined') {
      toReturn['extension'] = this.extension;
    }
    return toReturn;
  }
}
class FilterValue {
  static fromProto(proto) {
    let m = new FilterValue();
    m = Object.assign(m, proto);
    if (proto.integer) {
      m.integer = parseInt(proto.integer, 10);
    }
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.dateDefault) {
      m.dateDefault = enumStringToValue$7(DateDefault, proto.dateDefault);
    }
    if (proto.phone) {
      m.phone = Phone.fromProto(proto.phone);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.boolean !== 'undefined') {
      toReturn['boolean'] = this.boolean;
    }
    if (typeof this.integer !== 'undefined') {
      toReturn['integer'] = this.integer;
    }
    if (typeof this.float !== 'undefined') {
      toReturn['float'] = this.float;
    }
    if (typeof this.string !== 'undefined') {
      toReturn['string'] = this.string;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.dateDefault !== 'undefined') {
      toReturn['dateDefault'] = this.dateDefault;
    }
    if (typeof this.phone !== 'undefined' && this.phone !== null) {
      toReturn['phone'] = 'toApiJson' in this.phone ? this.phone.toApiJson() : this.phone;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ArchiveFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ArchiveFieldSchemaRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    return toReturn;
  }
}
class CreateFieldSchemaRequest {
  static fromProto(proto) {
    let m = new CreateFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = FieldSchema.fromProto(proto.fieldSchema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    return toReturn;
  }
}
class CreateFieldSchemaResponse {
  static fromProto(proto) {
    let m = new CreateFieldSchemaResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    return toReturn;
  }
}
class DropdownOption {
  static fromProto(proto) {
    let m = new DropdownOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class FieldSchema {
  static fromProto(proto) {
    let m = new FieldSchema();
    m = Object.assign(m, proto);
    if (proto.fieldType) {
      m.fieldType = enumStringToValue$6(FieldType, proto.fieldType);
    }
    if (proto.dropdownOptions) {
      m.dropdownOptions = proto.dropdownOptions.map(DropdownOption.fromProto);
    }
    if (proto.archived) {
      m.archived = new Date(proto.archived);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    if (typeof this.fieldName !== 'undefined') {
      toReturn['fieldName'] = this.fieldName;
    }
    if (typeof this.fieldDescription !== 'undefined') {
      toReturn['fieldDescription'] = this.fieldDescription;
    }
    if (typeof this.dropdownOptions !== 'undefined' && this.dropdownOptions !== null) {
      toReturn['dropdownOptions'] = 'toApiJson' in this.dropdownOptions ? this.dropdownOptions.toApiJson() : this.dropdownOptions;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.archived !== 'undefined' && this.archived !== null) {
      toReturn['archived'] = 'toApiJson' in this.archived ? this.archived.toApiJson() : this.archived;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.readonly !== 'undefined') {
      toReturn['readonly'] = this.readonly;
    }
    return toReturn;
  }
}
class ListFieldSchemaRequestFilters {
  static fromProto(proto) {
    let m = new ListFieldSchemaRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.onlyArchived !== 'undefined') {
      toReturn['onlyArchived'] = this.onlyArchived;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetMultiFieldSchemaRequest {
  static fromProto(proto) {
    let m = new GetMultiFieldSchemaRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    return toReturn;
  }
}
class GetMultiFieldSchemaResponse {
  static fromProto(proto) {
    let m = new GetMultiFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(FieldSchema.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    return toReturn;
  }
}
class ListFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ListFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = ListFieldSchemaRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListFieldSchemaResponse {
  static fromProto(proto) {
    let m = new ListFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(FieldSchema.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class UnarchiveFieldSchemaRequest {
  static fromProto(proto) {
    let m = new UnarchiveFieldSchemaRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    return toReturn;
  }
}
class UpdateFieldSchemaRequest {
  static fromProto(proto) {
    let m = new UpdateFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = FieldSchema.fromProto(proto.fieldSchema);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetOpportunityValueSummaryResponseAmounts {
  static fromProto(proto) {
    let m = new GetOpportunityValueSummaryResponseAmounts();
    m = Object.assign(m, proto);
    if (proto.total) {
      m.total = Currency.fromProto(proto.total);
    }
    if (proto.estimated) {
      m.estimated = Currency.fromProto(proto.estimated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.total !== 'undefined' && this.total !== null) {
      toReturn['total'] = 'toApiJson' in this.total ? this.total.toApiJson() : this.total;
    }
    if (typeof this.estimated !== 'undefined' && this.estimated !== null) {
      toReturn['estimated'] = 'toApiJson' in this.estimated ? this.estimated.toApiJson() : this.estimated;
    }
    return toReturn;
  }
}
class CreateCrmObjectRequest {
  static fromProto(proto) {
    let m = new CreateCrmObjectRequest();
    m = Object.assign(m, proto);
    if (proto.crmObject) {
      m.crmObject = CrmObject.fromProto(proto.crmObject);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObject !== 'undefined' && this.crmObject !== null) {
      toReturn['crmObject'] = 'toApiJson' in this.crmObject ? this.crmObject.toApiJson() : this.crmObject;
    }
    return toReturn;
  }
}
class CreateCrmObjectResponse {
  static fromProto(proto) {
    let m = new CreateCrmObjectResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    return toReturn;
  }
}
class CrmObject {
  static fromProto(proto) {
    let m = new CrmObject();
    m = Object.assign(m, proto);
    if (proto.fields) {
      m.fields = proto.fields.map(FieldValue.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.fields !== 'undefined' && this.fields !== null) {
      toReturn['fields'] = 'toApiJson' in this.fields ? this.fields.toApiJson() : this.fields;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    if (typeof this.idempotencyId !== 'undefined') {
      toReturn['idempotencyId'] = this.idempotencyId;
    }
    return toReturn;
  }
}
class CrmObjectSearch {
  static fromProto(proto) {
    let m = new CrmObjectSearch();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class Currency {
  static fromProto(proto) {
    let m = new Currency();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class DeleteCrmObjectRequest {
  static fromProto(proto) {
    let m = new DeleteCrmObjectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    return toReturn;
  }
}
class FieldValue {
  static fromProto(proto) {
    let m = new FieldValue();
    m = Object.assign(m, proto);
    if (proto.nullValue) {
      m.nullValue = enumStringToValue$5(NullValue, proto.nullValue);
    }
    if (proto.integerValue) {
      m.integerValue = parseInt(proto.integerValue, 10);
    }
    if (proto.dateValue) {
      m.dateValue = new Date(proto.dateValue);
    }
    if (proto.stringValues) {
      m.stringValues = StringList.fromProto(proto.stringValues);
    }
    if (proto.geopointValue) {
      m.geopointValue = Geopoint.fromProto(proto.geopointValue);
    }
    if (proto.phoneFieldValues) {
      m.phoneFieldValues = PhoneFields.fromProto(proto.phoneFieldValues);
    }
    if (proto.currencyValue) {
      m.currencyValue = Currency.fromProto(proto.currencyValue);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.nullValue !== 'undefined') {
      toReturn['nullValue'] = this.nullValue;
    }
    if (typeof this.integerValue !== 'undefined') {
      toReturn['integerValue'] = this.integerValue;
    }
    if (typeof this.stringValue !== 'undefined') {
      toReturn['stringValue'] = this.stringValue;
    }
    if (typeof this.dateValue !== 'undefined' && this.dateValue !== null) {
      toReturn['dateValue'] = 'toApiJson' in this.dateValue ? this.dateValue.toApiJson() : this.dateValue;
    }
    if (typeof this.booleanValue !== 'undefined') {
      toReturn['booleanValue'] = this.booleanValue;
    }
    if (typeof this.stringValues !== 'undefined' && this.stringValues !== null) {
      toReturn['stringValues'] = 'toApiJson' in this.stringValues ? this.stringValues.toApiJson() : this.stringValues;
    }
    if (typeof this.geopointValue !== 'undefined' && this.geopointValue !== null) {
      toReturn['geopointValue'] = 'toApiJson' in this.geopointValue ? this.geopointValue.toApiJson() : this.geopointValue;
    }
    if (typeof this.floatValue !== 'undefined') {
      toReturn['floatValue'] = this.floatValue;
    }
    if (typeof this.phoneFieldValues !== 'undefined' && this.phoneFieldValues !== null) {
      toReturn['phoneFieldValues'] = 'toApiJson' in this.phoneFieldValues ? this.phoneFieldValues.toApiJson() : this.phoneFieldValues;
    }
    if (typeof this.currencyValue !== 'undefined' && this.currencyValue !== null) {
      toReturn['currencyValue'] = 'toApiJson' in this.currencyValue ? this.currencyValue.toApiJson() : this.currencyValue;
    }
    return toReturn;
  }
}
class Geopoint {
  static fromProto(proto) {
    let m = new Geopoint();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lat !== 'undefined') {
      toReturn['lat'] = this.lat;
    }
    if (typeof this.lon !== 'undefined') {
      toReturn['lon'] = this.lon;
    }
    return toReturn;
  }
}
class GetMultiCrmObjectRequest {
  static fromProto(proto) {
    let m = new GetMultiCrmObjectRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.projectionFilters) {
      m.projectionFilters = proto.projectionFilters.map(ObjectProjectionFilter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectIds !== 'undefined') {
      toReturn['crmObjectIds'] = this.crmObjectIds;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.projectionFilters !== 'undefined' && this.projectionFilters !== null) {
      toReturn['projectionFilters'] = 'toApiJson' in this.projectionFilters ? this.projectionFilters.toApiJson() : this.projectionFilters;
    }
    return toReturn;
  }
}
class GetMultiCrmObjectResponse {
  static fromProto(proto) {
    let m = new GetMultiCrmObjectResponse();
    m = Object.assign(m, proto);
    if (proto.crmObjects) {
      m.crmObjects = proto.crmObjects.map(CrmObject.fromProto);
    }
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(FieldSchema.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjects !== 'undefined' && this.crmObjects !== null) {
      toReturn['crmObjects'] = 'toApiJson' in this.crmObjects ? this.crmObjects.toApiJson() : this.crmObjects;
    }
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    return toReturn;
  }
}
class GetOpportunityValueSummaryRequest {
  static fromProto(proto) {
    let m = new GetOpportunityValueSummaryRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = FilterGroup.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class GetOpportunityValueSummaryResponse {
  static fromProto(proto) {
    let m = new GetOpportunityValueSummaryResponse();
    m = Object.assign(m, proto);
    if (proto.stages) {
      m.stages = proto.stages.map(GetOpportunityValueSummaryResponseStageAmounts.fromProto);
    }
    if (proto.pipeline) {
      m.pipeline = GetOpportunityValueSummaryResponseAmounts.fromProto(proto.pipeline);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stages !== 'undefined' && this.stages !== null) {
      toReturn['stages'] = 'toApiJson' in this.stages ? this.stages.toApiJson() : this.stages;
    }
    if (typeof this.pipeline !== 'undefined' && this.pipeline !== null) {
      toReturn['pipeline'] = 'toApiJson' in this.pipeline ? this.pipeline.toApiJson() : this.pipeline;
    }
    return toReturn;
  }
}
class ListCrmObjectsRequest {
  static fromProto(proto) {
    let m = new ListCrmObjectsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.search) {
      m.search = CrmObjectSearch.fromProto(proto.search);
    }
    if (proto.sortBy) {
      m.sortBy = proto.sortBy.map(SortBy.fromProto);
    }
    if (proto.filtersV2) {
      m.filtersV2 = FilterGroup.fromProto(proto.filtersV2);
    }
    if (proto.projectionFilters) {
      m.projectionFilters = proto.projectionFilters.map(ObjectProjectionFilter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.search !== 'undefined' && this.search !== null) {
      toReturn['search'] = 'toApiJson' in this.search ? this.search.toApiJson() : this.search;
    }
    if (typeof this.sortBy !== 'undefined' && this.sortBy !== null) {
      toReturn['sortBy'] = 'toApiJson' in this.sortBy ? this.sortBy.toApiJson() : this.sortBy;
    }
    if (typeof this.filtersV2 !== 'undefined' && this.filtersV2 !== null) {
      toReturn['filtersV2'] = 'toApiJson' in this.filtersV2 ? this.filtersV2.toApiJson() : this.filtersV2;
    }
    if (typeof this.projectionFilters !== 'undefined' && this.projectionFilters !== null) {
      toReturn['projectionFilters'] = 'toApiJson' in this.projectionFilters ? this.projectionFilters.toApiJson() : this.projectionFilters;
    }
    return toReturn;
  }
}
class ListCrmObjectsResponse {
  static fromProto(proto) {
    let m = new ListCrmObjectsResponse();
    m = Object.assign(m, proto);
    if (proto.crmObjects) {
      m.crmObjects = proto.crmObjects.map(CrmObject.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjects !== 'undefined' && this.crmObjects !== null) {
      toReturn['crmObjects'] = 'toApiJson' in this.crmObjects ? this.crmObjects.toApiJson() : this.crmObjects;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListFieldOptionsRequest {
  static fromProto(proto) {
    let m = new ListFieldOptionsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    return toReturn;
  }
}
class ListFieldOptionsResponse {
  static fromProto(proto) {
    let m = new ListFieldOptionsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.options !== 'undefined') {
      toReturn['options'] = this.options;
    }
    return toReturn;
  }
}
class ListMultiLocationFieldOptionsRequest {
  static fromProto(proto) {
    let m = new ListMultiLocationFieldOptionsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespaces !== 'undefined') {
      toReturn['namespaces'] = this.namespaces;
    }
    if (typeof this.multiLocationPath !== 'undefined') {
      toReturn['multiLocationPath'] = this.multiLocationPath;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListMultiLocationFieldOptionsResponse {
  static fromProto(proto) {
    let m = new ListMultiLocationFieldOptionsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.options !== 'undefined') {
      toReturn['options'] = this.options;
    }
    return toReturn;
  }
}
class ObjectProjectionFilter {
  static fromProto(proto) {
    let m = new ObjectProjectionFilter();
    m = Object.assign(m, proto);
    if (proto.filterType) {
      m.filterType = enumStringToValue$5(ProjectionFilterType, proto.filterType);
    }
    if (proto.fromFieldType) {
      m.fromFieldType = enumStringToValue$5(FieldType, proto.fromFieldType);
    }
    if (proto.toFieldType) {
      m.toFieldType = enumStringToValue$5(FieldType, proto.toFieldType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filterType !== 'undefined') {
      toReturn['filterType'] = this.filterType;
    }
    if (typeof this.fromFieldType !== 'undefined') {
      toReturn['fromFieldType'] = this.fromFieldType;
    }
    if (typeof this.toFieldType !== 'undefined') {
      toReturn['toFieldType'] = this.toFieldType;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    return toReturn;
  }
}
class PhoneFields {
  static fromProto(proto) {
    let m = new PhoneFields();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isoCountryCode !== 'undefined') {
      toReturn['isoCountryCode'] = this.isoCountryCode;
    }
    if (typeof this.nationalNumber !== 'undefined') {
      toReturn['nationalNumber'] = this.nationalNumber;
    }
    if (typeof this.extension !== 'undefined') {
      toReturn['extension'] = this.extension;
    }
    if (typeof this.e164Compliant !== 'undefined') {
      toReturn['e164Compliant'] = this.e164Compliant;
    }
    return toReturn;
  }
}
class SortBy {
  static fromProto(proto) {
    let m = new SortBy();
    m = Object.assign(m, proto);
    if (proto.sortDirection) {
      m.sortDirection = enumStringToValue$5(SortDirection, proto.sortDirection);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.sortDirection !== 'undefined') {
      toReturn['sortDirection'] = this.sortDirection;
    }
    return toReturn;
  }
}
class GetOpportunityValueSummaryResponseStageAmounts {
  static fromProto(proto) {
    let m = new GetOpportunityValueSummaryResponseStageAmounts();
    m = Object.assign(m, proto);
    if (proto.amounts) {
      m.amounts = GetOpportunityValueSummaryResponseAmounts.fromProto(proto.amounts);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stageId !== 'undefined') {
      toReturn['stageId'] = this.stageId;
    }
    if (typeof this.amounts !== 'undefined' && this.amounts !== null) {
      toReturn['amounts'] = 'toApiJson' in this.amounts ? this.amounts.toApiJson() : this.amounts;
    }
    return toReturn;
  }
}
class StartBulkCompanyCreateRequest {
  static fromProto(proto) {
    let m = new StartBulkCompanyCreateRequest();
    m = Object.assign(m, proto);
    if (proto.crmObjects) {
      m.crmObjects = proto.crmObjects.map(CrmObject.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.crmObjects !== 'undefined' && this.crmObjects !== null) {
      toReturn['crmObjects'] = 'toApiJson' in this.crmObjects ? this.crmObjects.toApiJson() : this.crmObjects;
    }
    return toReturn;
  }
}
class StartBulkCompanyCreateResponse {
  static fromProto(proto) {
    let m = new StartBulkCompanyCreateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filterTag !== 'undefined') {
      toReturn['filterTag'] = this.filterTag;
    }
    return toReturn;
  }
}
class StringList {
  static fromProto(proto) {
    let m = new StringList();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.values !== 'undefined') {
      toReturn['values'] = this.values;
    }
    return toReturn;
  }
}
class ValidateCrmObjectResponseUniquenessCheck {
  static fromProto(proto) {
    let m = new ValidateCrmObjectResponseUniquenessCheck();
    m = Object.assign(m, proto);
    if (proto.uniqueness) {
      m.uniqueness = enumStringToValue$5(ValidateCrmObjectResponseFieldUniqueness, proto.uniqueness);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.existingCrmObjectIds !== 'undefined') {
      toReturn['existingCrmObjectIds'] = this.existingCrmObjectIds;
    }
    if (typeof this.uniqueness !== 'undefined') {
      toReturn['uniqueness'] = this.uniqueness;
    }
    return toReturn;
  }
}
class UpdateCrmObjectRequest {
  static fromProto(proto) {
    let m = new UpdateCrmObjectRequest();
    m = Object.assign(m, proto);
    if (proto.crmObject) {
      m.crmObject = CrmObject.fromProto(proto.crmObject);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObject !== 'undefined' && this.crmObject !== null) {
      toReturn['crmObject'] = 'toApiJson' in this.crmObject ? this.crmObject.toApiJson() : this.crmObject;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class ValidateCrmObjectRequest {
  static fromProto(proto) {
    let m = new ValidateCrmObjectRequest();
    m = Object.assign(m, proto);
    if (proto.crmObject) {
      m.crmObject = CrmObject.fromProto(proto.crmObject);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObject !== 'undefined' && this.crmObject !== null) {
      toReturn['crmObject'] = 'toApiJson' in this.crmObject ? this.crmObject.toApiJson() : this.crmObject;
    }
    return toReturn;
  }
}
class ValidateCrmObjectResponse {
  static fromProto(proto) {
    let m = new ValidateCrmObjectResponse();
    m = Object.assign(m, proto);
    if (proto.errors) {
      m.errors = proto.errors.map(ValidateCrmObjectResponseValidationError.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.errors !== 'undefined' && this.errors !== null) {
      toReturn['errors'] = 'toApiJson' in this.errors ? this.errors.toApiJson() : this.errors;
    }
    return toReturn;
  }
}
class ValidateCrmObjectResponseValidationError {
  static fromProto(proto) {
    let m = new ValidateCrmObjectResponseValidationError();
    m = Object.assign(m, proto);
    if (proto.severity) {
      m.severity = enumStringToValue$5(ValidateCrmObjectResponseValidationErrorSeverity, proto.severity);
    }
    if (proto.details) {
      m.details = ValidateCrmObjectResponseValidationErrorDetails.fromProto(proto.details);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ruleId !== 'undefined') {
      toReturn['ruleId'] = this.ruleId;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.severity !== 'undefined') {
      toReturn['severity'] = this.severity;
    }
    if (typeof this.details !== 'undefined' && this.details !== null) {
      toReturn['details'] = 'toApiJson' in this.details ? this.details.toApiJson() : this.details;
    }
    return toReturn;
  }
}
class ValidateCrmObjectResponseValidationErrorDetails {
  static fromProto(proto) {
    let m = new ValidateCrmObjectResponseValidationErrorDetails();
    m = Object.assign(m, proto);
    if (proto.uniquenessCheck) {
      m.uniquenessCheck = ValidateCrmObjectResponseUniquenessCheck.fromProto(proto.uniquenessCheck);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.uniquenessCheck !== 'undefined' && this.uniquenessCheck !== null) {
      toReturn['uniquenessCheck'] = 'toApiJson' in this.uniquenessCheck ? this.uniquenessCheck.toApiJson() : this.uniquenessCheck;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DeleteObjectRequest {
  static fromProto(proto) {
    let m = new DeleteObjectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.jsonData !== 'undefined') {
      toReturn['jsonData'] = this.jsonData;
    }
    return toReturn;
  }
}
class ImportFromJSONRequest {
  static fromProto(proto) {
    let m = new ImportFromJSONRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.existingRecordChecks !== 'undefined') {
      toReturn['existingRecordChecks'] = this.existingRecordChecks;
    }
    if (typeof this.fieldData !== 'undefined') {
      toReturn['fieldData'] = this.fieldData;
    }
    if (typeof this.readMask !== 'undefined') {
      toReturn['readMask'] = this.readMask;
    }
    return toReturn;
  }
}
class ImportFromJSONResponse {
  static fromProto(proto) {
    let m = new ImportFromJSONResponse();
    m = Object.assign(m, proto);
    if (proto.fields) {
      m.fields = proto.fields.map(FieldValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    if (typeof this.fields !== 'undefined' && this.fields !== null) {
      toReturn['fields'] = 'toApiJson' in this.fields ? this.fields.toApiJson() : this.fields;
    }
    return toReturn;
  }
}
class UpsertObjectResponseMultiIngestionResponse {
  static fromProto(proto) {
    let m = new UpsertObjectResponseMultiIngestionResponse();
    m = Object.assign(m, proto);
    if (proto.workflowStatus) {
      m.workflowStatus = enumStringToValue$4(WorkflowStatus, proto.workflowStatus);
    }
    if (proto.result) {
      m.result = UpsertObjectResponseMultiIngestionResult.fromProto(proto.result);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.workflowStatus !== 'undefined') {
      toReturn['workflowStatus'] = this.workflowStatus;
    }
    if (typeof this.result !== 'undefined' && this.result !== null) {
      toReturn['result'] = 'toApiJson' in this.result ? this.result.toApiJson() : this.result;
    }
    if (typeof this.workflowId !== 'undefined') {
      toReturn['workflowId'] = this.workflowId;
    }
    return toReturn;
  }
}
class UpsertObjectResponseMultiIngestionResult {
  static fromProto(proto) {
    let m = new UpsertObjectResponseMultiIngestionResult();
    m = Object.assign(m, proto);
    if (proto.nestedObjects) {
      m.nestedObjects = proto.nestedObjects.map(UpsertObjectResponseNestedObject.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    if (typeof this.nestedObjects !== 'undefined' && this.nestedObjects !== null) {
      toReturn['nestedObjects'] = 'toApiJson' in this.nestedObjects ? this.nestedObjects.toApiJson() : this.nestedObjects;
    }
    return toReturn;
  }
}
class UpsertObjectResponseNestedObject {
  static fromProto(proto) {
    let m = new UpsertObjectResponseNestedObject();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    if (typeof this.objectType !== 'undefined') {
      toReturn['objectType'] = this.objectType;
    }
    return toReturn;
  }
}
class UpsertObjectRequest {
  static fromProto(proto) {
    let m = new UpsertObjectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.jsonData !== 'undefined') {
      toReturn['jsonData'] = this.jsonData;
    }
    return toReturn;
  }
}
class UpsertObjectResponse {
  static fromProto(proto) {
    let m = new UpsertObjectResponse();
    m = Object.assign(m, proto);
    if (proto.multiIngestionResponse) {
      m.multiIngestionResponse = UpsertObjectResponseMultiIngestionResponse.fromProto(proto.multiIngestionResponse);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    if (typeof this.multiIngestionResponse !== 'undefined' && this.multiIngestionResponse !== null) {
      toReturn['multiIngestionResponse'] = 'toApiJson' in this.multiIngestionResponse ? this.multiIngestionResponse.toApiJson() : this.multiIngestionResponse;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddContactAsIamUserForCompanyRequest {
  static fromProto(proto) {
    let m = new AddContactAsIamUserForCompanyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.companyId !== 'undefined') {
      toReturn['companyId'] = this.companyId;
    }
    if (typeof this.sendWelcomeEmail !== 'undefined') {
      toReturn['sendWelcomeEmail'] = this.sendWelcomeEmail;
    }
    return toReturn;
  }
}
class AddContactAsIamUserForCompanyStatusResponse {
  static fromProto(proto) {
    let m = new AddContactAsIamUserForCompanyStatusResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$3(AddContactAsIamUserForCompanyStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class CreateAccountGroupForCompanyRequest {
  static fromProto(proto) {
    let m = new CreateAccountGroupForCompanyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyId !== 'undefined') {
      toReturn['companyId'] = this.companyId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetAccountGroupForCompanyRequest {
  static fromProto(proto) {
    let m = new GetAccountGroupForCompanyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyId !== 'undefined') {
      toReturn['companyId'] = this.companyId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetAccountGroupForCompanyResponse {
  static fromProto(proto) {
    let m = new GetAccountGroupForCompanyResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetCreateAccountGroupForCompanyStatusRequest {
  static fromProto(proto) {
    let m = new GetCreateAccountGroupForCompanyStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyId !== 'undefined') {
      toReturn['companyId'] = this.companyId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetCreateAccountGroupForCompanyStatusResponse {
  static fromProto(proto) {
    let m = new GetCreateAccountGroupForCompanyStatusResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$3(CreateAccountGroupForCompanyStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetWebsiteActivityForVisitorRequest {
  static fromProto(proto) {
    let m = new GetWebsiteActivityForVisitorRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.visitorId !== 'undefined') {
      toReturn['visitorId'] = this.visitorId;
    }
    return toReturn;
  }
}
class GetWebsiteActivityForVisitorResponse {
  static fromProto(proto) {
    let m = new GetWebsiteActivityForVisitorResponse();
    m = Object.assign(m, proto);
    if (proto.pageView) {
      m.pageView = PageView.fromProto(proto.pageView);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageView !== 'undefined' && this.pageView !== null) {
      toReturn['pageView'] = 'toApiJson' in this.pageView ? this.pageView.toApiJson() : this.pageView;
    }
    return toReturn;
  }
}
class InferCompanyCategoriesRequest {
  static fromProto(proto) {
    let m = new InferCompanyCategoriesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.companyId !== 'undefined') {
      toReturn['companyId'] = this.companyId;
    }
    return toReturn;
  }
}
class IsContactIamUserForCompanyRequest {
  static fromProto(proto) {
    let m = new IsContactIamUserForCompanyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.companyId !== 'undefined') {
      toReturn['companyId'] = this.companyId;
    }
    return toReturn;
  }
}
class IsContactIamUserForCompanyResponse {
  static fromProto(proto) {
    let m = new IsContactIamUserForCompanyResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isIamUser !== 'undefined') {
      toReturn['isIamUser'] = this.isIamUser;
    }
    return toReturn;
  }
}
class PageView {
  static fromProto(proto) {
    let m = new PageView();
    m = Object.assign(m, proto);
    if (proto.timestamp) {
      m.timestamp = new Date(proto.timestamp);
    }
    if (proto.utmAttributes) {
      m.utmAttributes = UTMAttributes.fromProto(proto.utmAttributes);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.timestamp !== 'undefined' && this.timestamp !== null) {
      toReturn['timestamp'] = 'toApiJson' in this.timestamp ? this.timestamp.toApiJson() : this.timestamp;
    }
    if (typeof this.utmAttributes !== 'undefined' && this.utmAttributes !== null) {
      toReturn['utmAttributes'] = 'toApiJson' in this.utmAttributes ? this.utmAttributes.toApiJson() : this.utmAttributes;
    }
    if (typeof this.referrer !== 'undefined') {
      toReturn['referrer'] = this.referrer;
    }
    if (typeof this.referringDomain !== 'undefined') {
      toReturn['referringDomain'] = this.referringDomain;
    }
    return toReturn;
  }
}
class RemoveContactAsIamUserForCompanyRequest {
  static fromProto(proto) {
    let m = new RemoveContactAsIamUserForCompanyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.companyId !== 'undefined') {
      toReturn['companyId'] = this.companyId;
    }
    return toReturn;
  }
}
class UTMAttributes {
  static fromProto(proto) {
    let m = new UTMAttributes();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.utmCampaign !== 'undefined') {
      toReturn['utmCampaign'] = this.utmCampaign;
    }
    if (typeof this.utmMedium !== 'undefined') {
      toReturn['utmMedium'] = this.utmMedium;
    }
    if (typeof this.utmSource !== 'undefined') {
      toReturn['utmSource'] = this.utmSource;
    }
    if (typeof this.utmContent !== 'undefined') {
      toReturn['utmContent'] = this.utmContent;
    }
    if (typeof this.utmTerm !== 'undefined') {
      toReturn['utmTerm'] = this.utmTerm;
    }
    if (typeof this.gclid !== 'undefined') {
      toReturn['gclid'] = this.gclid;
    }
    if (typeof this.fbclid !== 'undefined') {
      toReturn['fbclid'] = this.fbclid;
    }
    if (typeof this.msclkid !== 'undefined') {
      toReturn['msclkid'] = this.msclkid;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetAISummaryForCRMObjectRequest {
  static fromProto(proto) {
    let m = new GetAISummaryForCRMObjectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.crmObjectNamespace !== 'undefined') {
      toReturn['crmObjectNamespace'] = this.crmObjectNamespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectId !== 'undefined') {
      toReturn['crmObjectId'] = this.crmObjectId;
    }
    if (typeof this.language !== 'undefined') {
      toReturn['language'] = this.language;
    }
    if (typeof this.regenerateSummary !== 'undefined') {
      toReturn['regenerateSummary'] = this.regenerateSummary;
    }
    return toReturn;
  }
}
class GetAISummaryForCRMObjectResponse {
  static fromProto(proto) {
    let m = new GetAISummaryForCRMObjectResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.response !== 'undefined') {
      toReturn['response'] = this.response;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class StartManualAutomationsRequestStartAutomationCriteria {
  static fromProto(proto) {
    let m = new StartManualAutomationsRequestStartAutomationCriteria();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = FilterGroup.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.objectType !== 'undefined') {
      toReturn['objectType'] = this.objectType;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class StartManualAutomationsRequestStartAutomationPayload {
  static fromProto(proto) {
    let m = new StartManualAutomationsRequestStartAutomationPayload();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.data !== 'undefined') {
      toReturn['data'] = this.data;
    }
    return toReturn;
  }
}
class StartManualAutomationsRequest {
  static fromProto(proto) {
    let m = new StartManualAutomationsRequest();
    m = Object.assign(m, proto);
    if (proto.payload) {
      m.payload = StartManualAutomationsRequestStartAutomationPayload.fromProto(proto.payload);
    }
    if (proto.criteria) {
      m.criteria = StartManualAutomationsRequestStartAutomationCriteria.fromProto(proto.criteria);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.payload !== 'undefined' && this.payload !== null) {
      toReturn['payload'] = 'toApiJson' in this.payload ? this.payload.toApiJson() : this.payload;
    }
    if (typeof this.criteria !== 'undefined' && this.criteria !== null) {
      toReturn['criteria'] = 'toApiJson' in this.criteria ? this.criteria.toApiJson() : this.criteria;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'crm-integrations-api.vendasta-local.com',
  'test': '',
  'demo': 'crm-integrations-demo.apigateway.co',
  'prod': 'crm-integrations-prod.apigateway.co',
  'production': 'crm-integrations-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CrmAIApiService = /*#__PURE__*/(() => {
  class CrmAIApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getAiSummaryForCrmObject(r) {
      const request = r.toApiJson ? r : new GetAISummaryForCRMObjectRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.CrmAIService/GetAISummaryForCRMObject", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAISummaryForCRMObjectResponse.fromProto(resp)));
    }
  }
  CrmAIApiService.ɵfac = function CrmAIApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CrmAIApiService)();
  };
  CrmAIApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CrmAIApiService,
    factory: CrmAIApiService.ɵfac,
    providedIn: 'root'
  });
  return CrmAIApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CrmAutomationApiService = /*#__PURE__*/(() => {
  class CrmAutomationApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    startManualAutomations(r) {
      const request = r.toApiJson ? r : new StartManualAutomationsRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.CrmAutomationService/StartManualAutomations", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CrmAutomationApiService.ɵfac = function CrmAutomationApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CrmAutomationApiService)();
  };
  CrmAutomationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CrmAutomationApiService,
    factory: CrmAutomationApiService.ɵfac,
    providedIn: 'root'
  });
  return CrmAutomationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let DataIngestionApiService = /*#__PURE__*/(() => {
  class DataIngestionApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    upsertObject(r) {
      const request = r.toApiJson ? r : new UpsertObjectRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.DataIngestionService/UpsertObject", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpsertObjectResponse.fromProto(resp)));
    }
    deleteObject(r) {
      const request = r.toApiJson ? r : new DeleteObjectRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.DataIngestionService/DeleteObject", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    importFromJson(r) {
      const request = r.toApiJson ? r : new ImportFromJSONRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.DataIngestionService/ImportFromJSON", request.toApiJson(), this.apiOptions()).pipe(map(resp => ImportFromJSONResponse.fromProto(resp)));
    }
  }
  DataIngestionApiService.ɵfac = function DataIngestionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DataIngestionApiService)();
  };
  DataIngestionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DataIngestionApiService,
    factory: DataIngestionApiService.ɵfac,
    providedIn: 'root'
  });
  return DataIngestionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let IntegrationApiService = /*#__PURE__*/(() => {
  class IntegrationApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createIntegration(r) {
      const request = r.toApiJson ? r : new CreateIntegrationRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.IntegrationService/CreateIntegration", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateIntegrationResponse.fromProto(resp)));
    }
    updateIntegration(r) {
      const request = r.toApiJson ? r : new UpdateIntegrationRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.IntegrationService/UpdateIntegration", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteIntegration(r) {
      const request = r.toApiJson ? r : new DeleteIntegrationRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.IntegrationService/DeleteIntegration", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiIntegration(r) {
      const request = r.toApiJson ? r : new GetMultiIntegrationRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.IntegrationService/GetMultiIntegration", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiIntegrationResponse.fromProto(resp)));
    }
  }
  IntegrationApiService.ɵfac = function IntegrationApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IntegrationApiService)();
  };
  IntegrationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IntegrationApiService,
    factory: IntegrationApiService.ɵfac,
    providedIn: 'root'
  });
  return IntegrationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PlatformApiService = /*#__PURE__*/(() => {
  class PlatformApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createAccountGroupForCompany(r) {
      const request = r.toApiJson ? r : new CreateAccountGroupForCompanyRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.PlatformService/CreateAccountGroupForCompany", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getCreateAccountGroupForCompanyStatus(r) {
      const request = r.toApiJson ? r : new GetCreateAccountGroupForCompanyStatusRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.PlatformService/GetCreateAccountGroupForCompanyStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCreateAccountGroupForCompanyStatusResponse.fromProto(resp)));
    }
    getAccountGroupForCompany(r) {
      const request = r.toApiJson ? r : new GetAccountGroupForCompanyRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.PlatformService/GetAccountGroupForCompany", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAccountGroupForCompanyResponse.fromProto(resp)));
    }
    addContactAsIamUserForCompany(r) {
      const request = r.toApiJson ? r : new AddContactAsIamUserForCompanyRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.PlatformService/AddContactAsIamUserForCompany", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddContactAsIamUserForCompanyStatusResponse.fromProto(resp)));
    }
    isContactIamUserForCompany(r) {
      const request = r.toApiJson ? r : new IsContactIamUserForCompanyRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.PlatformService/IsContactIamUserForCompany", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsContactIamUserForCompanyResponse.fromProto(resp)));
    }
    removeContactAsIamUserForCompany(r) {
      const request = r.toApiJson ? r : new RemoveContactAsIamUserForCompanyRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.PlatformService/RemoveContactAsIamUserForCompany", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getWebsiteActivityForVisitor(r) {
      const request = r.toApiJson ? r : new GetWebsiteActivityForVisitorRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.PlatformService/GetWebsiteActivityForVisitor", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetWebsiteActivityForVisitorResponse.fromProto(resp)));
    }
    inferCompanyCategories(r) {
      const request = r.toApiJson ? r : new InferCompanyCategoriesRequest(r);
      return this.http.post(this._host + "/crm_integrations.v1.PlatformService/InferCompanyCategories", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  PlatformApiService.ɵfac = function PlatformApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PlatformApiService)();
  };
  PlatformApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PlatformApiService,
    factory: PlatformApiService.ɵfac,
    providedIn: 'root'
  });
  return PlatformApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

// MANUALLY CREATED FILE
// Don't delete this by mistake when you update the SDK with mscli!

/**
 * Generated bundle index. Do not edit.
 */

export { Access, AddContactAsIamUserForCompanyRequest, AddContactAsIamUserForCompanyStatus, AddContactAsIamUserForCompanyStatusResponse, ArchiveFieldSchemaRequest, CreateAccountGroupForCompanyRequest, CreateAccountGroupForCompanyStatus, CreateCrmObjectRequest, CreateCrmObjectResponse, CreateFieldSchemaRequest, CreateFieldSchemaResponse, CreateIntegrationRequest, CreateIntegrationResponse, CrmAIApiService, CrmAutomationApiService, CrmObject, CrmObjectSearch, Currency, DataIngestionApiService, DateDefault, DeleteCrmObjectRequest, DeleteIntegrationRequest, DeleteObjectRequest, DropdownOption, FieldMapping, FieldMask, FieldSchema, FieldType, FieldValue, Filter, FilterGroup, FilterGroupOperator, FilterOperator, FilterType, FilterValue, Geopoint, GetAISummaryForCRMObjectRequest, GetAISummaryForCRMObjectResponse, GetAccountGroupForCompanyRequest, GetAccountGroupForCompanyResponse, GetCreateAccountGroupForCompanyStatusRequest, GetCreateAccountGroupForCompanyStatusResponse, GetMultiCrmObjectRequest, GetMultiCrmObjectResponse, GetMultiFieldSchemaRequest, GetMultiFieldSchemaResponse, GetMultiIntegrationRequest, GetMultiIntegrationResponse, GetOpportunityValueSummaryRequest, GetOpportunityValueSummaryResponse, GetOpportunityValueSummaryResponseAmounts, GetOpportunityValueSummaryResponseStageAmounts, GetWebsiteActivityForVisitorRequest, GetWebsiteActivityForVisitorResponse, HostService, ImportFromJSONRequest, ImportFromJSONResponse, InferCompanyCategoriesRequest, Integration, IntegrationApiService, IsContactIamUserForCompanyRequest, IsContactIamUserForCompanyResponse, ListCrmObjectsRequest, ListCrmObjectsResponse, ListFieldOptionsRequest, ListFieldOptionsResponse, ListFieldSchemaRequest, ListFieldSchemaRequestFilters, ListFieldSchemaResponse, ListMultiLocationFieldOptionsRequest, ListMultiLocationFieldOptionsResponse, MappingType, MergeStrategy, MergeStrategyMergeConfig, MergeStrategyMergeConfigDateOverwriteConfig, MergeStrategyType, NestedIntegration, NullValue, ObjectProjectionFilter, PageView, PagedRequestOptions, PagedResponseMetadata, Phone, PhoneFields, PlatformApiService, ProjectionFilterType, RemoveContactAsIamUserForCompanyRequest, SortBy, SortDirection, StartBulkCompanyCreateRequest, StartBulkCompanyCreateResponse, StartManualAutomationsRequest, StartManualAutomationsRequestStartAutomationCriteria, StartManualAutomationsRequestStartAutomationPayload, StringList, UTMAttributes, UnarchiveFieldSchemaRequest, UpdateCrmObjectRequest, UpdateFieldSchemaRequest, UpdateIntegrationRequest, UpsertObjectRequest, UpsertObjectResponse, UpsertObjectResponseMultiIngestionResponse, UpsertObjectResponseMultiIngestionResult, UpsertObjectResponseNestedObject, ValidateCrmObjectRequest, ValidateCrmObjectResponse, ValidateCrmObjectResponseFieldUniqueness, ValidateCrmObjectResponseUniquenessCheck, ValidateCrmObjectResponseValidationError, ValidateCrmObjectResponseValidationErrorDetails, ValidateCrmObjectResponseValidationErrorSeverity, WorkflowStatus };
